import * as yup from 'yup';

// The validator runs against a real FileList or a test shim (a plain object
// with `length`/`item`), so match on that structural shape rather than
// `instanceof FileList`.
interface FileListLike {
    length: number;
    item: (index: number) => File | null;
}

const isFileListLike = (value: unknown): value is FileListLike =>
    typeof value === 'object' &&
    value !== null &&
    'length' in value &&
    typeof value.length === 'number' &&
    'item' in value &&
    typeof value.item === 'function';

// We can't add this directly to a schema via yup.addMethod() because typescript typing does not seem to work for yup.mixed()
export function fileMaxSize(maxMB: number, message: string) {
    return yup.mixed().test('max-size', message, (value) => {
        if (!isFileListLike(value) || value.length < 1) {
            return true;
        }
        const validateFile = value.item(0);
        return !validateFile || validateFile.size <= maxMB * 1024 * 1024;
    });
}

export * from 'yup';
